import config from "./config.js";
import Identity from "./libs/snake.lib.identity.js";
import Component from "./component.js";
import Url from "./libs/snake.lib.url.js";
import Storage from "./libs/snake.lib.storage.js";
import Utils from "./libs/snake.lib.utils.js";
import Trace from "./libs/snake.lib.trace.js";
import Hook from "./libs/snake.lib.hook.js";
import Summary from "./libs/snake.lib.summary.js";
import ApiService from "./libs/snake.lib.api.js";
import AnalyticsService from "./libs/snake.lib.analytics.js";
import Router from "./libs/snake.lib.router.js";
import * as Sentry from "@sentry/browser";

export default class Checkout {
    static init = async () => {
        try {
            Trace.enabled = Storage.get("debug") === "1" || (import.meta.env.CO_SENTRY_ENV !== "deagostini_production" && import.meta.env.CO_SENTRY_ENV !== "fanhome_production");

            const [items, subscription] = Url.getParametes(["cart_id", "sku"]);

            window.snakeCheckout.type = items ? "items" : subscription ? "subscription" : "";
            window.snakeCheckout.currentCountry = Url.getCurrentUri().split("/")[1];

            if (window.snakeCheckout.type === "items") {
                document.querySelector("body").classList.add("items");
            }

            Router.get(`/${window.snakeCheckout.currentCountry}/purchase`, async () => {
                if (Url.getParametes("agent-customer")) await this.#initAgentCustomerCheckout();
                else await this.#initCustomerCheckout();
            });

            Router.get(`/${window.snakeCheckout.currentCountry}/purchase/confirmation`, async () => {
                await this.#renderItemsThankYouPage();
            });

            Router.get(`/${window.snakeCheckout.currentCountry}/purchase/confirmation-agent`, async () => {
                await this.#renderItemsThankYouPage();
            });

            Router.get(`/${window.snakeCheckout.currentCountry}/purchase/confirmation-customer-agent`, () => {
                this.#renderAgentThankYouPage();
            });

            Router.get(`/${window.snakeCheckout.currentCountry}/purchase/confirmation-mail-agent`, () => {
                this.#renderAgentThankYouPage();
            });

            Router.get(`/${window.snakeCheckout.currentCountry}/subscribe`, async () => {
                if (Url.getParametes("agent-customer")) await this.#initAgentCustomerCheckout();
                else await this.#initCustomerCheckout();
            });

            Router.get(`/${window.snakeCheckout.currentCountry}/subscribe/confirmation`, async () => {
                await this.#renderSubscriptionThankYouPage();
            });

            Router.get(`/${window.snakeCheckout.currentCountry}/subscribe/confirmation-agent`, async () => {
                await this.#renderSubscriptionThankYouPage();
            });

            Router.get(`/${window.snakeCheckout.currentCountry}/subscribe/confirmation-customer-agent`, async () => {
                this.#renderAgentThankYouPage();
            });

            Router.get(`/${window.snakeCheckout.currentCountry}/subscribe/confirmation-mail-agent`, () => {
                this.#renderAgentThankYouPage();
            });

            Router.get(`/${window.snakeCheckout.currentCountry}/verify`, async () => {
                Utils.spinner("loader", true);

                document.querySelector("main").innerHTML = "";

                const [redirectResult, orderId] = Url.getParametes(["redirectResult", "order_id"]);

                const errorMessage = () => {
                    let reloadUrl = `/${window.snakeCheckout.currentCountry}/`;
                    const currentPurchase = Storage.get("current_purchase");

                    if (currentPurchase) reloadUrl = (currentPurchase.includes("-") ? "purchase?cart_id=" : "subscribe?sku=") + currentPurchase;

                    Trace.debug("errorMessage");
                    Trace.debug(reloadUrl);
                    Trace.debug(currentPurchase);

                    document.querySelector("main").innerHTML = "<div class='col-span-12 px-4 md:px-0 text-center'><img class='mx-auto my-5 w-32' style='content: var(--error-icon)' /><div class='text-primary text-3xl font-semibold'>Payment verify error!</div><a class='button my-10 mx-auto w-fit min-w-0 no-underline text-white' href='" + reloadUrl + "' target='_self'><span class='pt-1'>Reload</span><svg aria-hidden='true' fill='currentColor' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' d='M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z' clip-rule='evenodd'></path></svg></a></div>";
                };

                await ApiService.paymentVerify(redirectResult, orderId)
                    .then(async (result) => {
                        Trace.debug("paymentVerify");
                        Trace.debug(result);
                        Trace.debug(result?.data?.payment?.resultCode);

                        let reloadUrl = `/${window.snakeCheckout.currentCountry}/`;
                        const currentPurchase = Storage.get("current_purchase");
                        const paymentMethod = Storage.get("payment_method");

                        switch (result?.data?.payment?.resultCode || null) {
                            case "Authorised":
                                await ApiService.completeOrder(parseInt(orderId), paymentMethod || "", Storage.get("invoice") || false)
                                    .then((response) => {
                                        Trace.debug("completeOrder");
                                        Trace.debug(response);

                                        const initData = JSON.parse(Storage.get("init"));
                                        const order = Storage.get("order");
                                        const items = Storage.get("items");
                                        const currentPurchase = Storage.get("current_purchase");
                                        const firstName = Storage.get("firstname");
                                        const promotions = Storage.get("promotions");
                                        const isAgent = Storage.get("agent") === "true";
                                        const defaultShippingAddress = JSON.parse(Storage.get("shipping_address"));

                                        Storage.clear(() => {
                                            Trace.debug("completeOrder clear");

                                            /**
                                             * Save some info on Local Storage to be able to use them on the Thank You page
                                             */
                                            Storage.set("init", JSON.stringify(initData));
                                            Storage.set("payment_method", paymentMethod);
                                            Storage.set("firstname", firstName);
                                            Storage.set("IOD", result?.data?.payment?.merchantReference);
                                            Storage.set("items", items);
                                            Storage.set("order", order);
                                            Storage.set("current_purchase", currentPurchase);
                                            Storage.set("promotions", promotions);
                                            Storage.set("shipping_address", JSON.stringify(defaultShippingAddress));

                                            if (window?.snakeCheckout?.shippingEstimationText) Storage.set("shipping_text", window.snakeCheckout.shippingEstimationText);

                                            setTimeout(() => {
                                                window.location.href = "/" + config.countries[window.snakeCheckout.currentCountry].countryCode.toLowerCase() + "/subscribe/confirmation" + (isAgent ? "-agent" : "");
                                            }, 500);
                                        });
                                    })
                                    .catch((e) => {
                                        Trace.debug("ER 1");
                                        Trace.debug(e);

                                        AnalyticsService.errorEvent("5_payment_verify", "technical", "snakeAPI | commerce order complete error", e);

                                        errorMessage();
                                    });
                                break;
                            case "Cancelled":
                                Trace.debug("cancelled");

                                if (currentPurchase) reloadUrl = (currentPurchase.includes("-") ? "purchase?cart_id=" : "subscribe?sku=") + currentPurchase;

                                window.location.href = reloadUrl;
                                break;
                            default:
                                Trace.debug("default");

                                AnalyticsService.checkoutPurchaseFailed();

                                AnalyticsService.errorEvent("5_payment_verify", "technical", "Payment verify unmapped case", result);

                                errorMessage();
                                break;
                        }
                    })
                    .catch((e) => {
                        Trace.debug("ER 2");
                        Trace.debug(e);

                        AnalyticsService.errorEvent("5_payment_verify", "technical", "Payment verify error", e);

                        errorMessage();
                    });

                Utils.spinner("loader", false);
            });
        } catch (e) {
            Trace.debug("ER 3");
            Trace.debug(e);

            AnalyticsService.errorEvent("0_init", "technical", "checkout init error", e);
        }
    };

    static #initCustomerCheckout = async () => {
        Utils.spinner("loader", true);

        const [agent, medium, source] = Url.getParametes(["agent", "medium", "source"]);

        const showPurchaseInitError = () => {
            Utils.modal("popup", true, { text: window.snakeCheckout.translations["error.generic"], dismissBtn: window.snakeCheckout.translations["modal.close"] });

            document.querySelector("main").innerHTML = "";
        };

        Storage.delete("firstname");
        Storage.delete("payment_method");
        Storage.delete("promotions");

        Storage.delete("agentCustomer");

        if (agent) Storage.set("agent", true);
        else Storage.delete("agent");

        if (medium) Storage.set("medium", medium);

        if (source) Storage.set("source", source);

        const purchaseInitObject = this.#initPurchaseObject();

        if (purchaseInitObject) {
            try {
                const response = await ApiService.purchaseInit(purchaseInitObject);

                Storage.set("cart_" + window.snakeCheckout.currentCountry, response.data.cart_id);
                window.snakeCheckout.initData = response.data;

                /**
                 * Save the init data on Local Storage to be able to use it for the analytics on
                 * Thank You page
                 */
                Storage.set("init", JSON.stringify(window.snakeCheckout.initData));

                if (window.snakeCheckout.type === "subscription") AnalyticsService.checkoutInitLoad();

                /**
                 * This event is sent in the Summary Load method when the price of the first shipment becomes available.
                 * We wait for this event because it's the only way to get the price that we need to send with the "begin_checkout" tracking event in the checkoutInitLoad method.
                 */
                await Identity._gproxyLoader(Url.getParametes("token"));

                Hook.attachListeners();
                Summary.load();
                Component.load(config.routing.sections.load.component);
            } catch (e) {
                Sentry.captureException(e);
                showPurchaseInitError();
                AnalyticsService.errorEvent("0_init", "technical", "snakeAPI | purchase init error", e);
            }
        } else {
            showPurchaseInitError();
            AnalyticsService.errorEvent("0_init", "technical", "missing variant or items");
        }

        Utils.spinner("loader", false);
    };

    static #initPurchaseObject = () => {
        // TODO: rename "items" => "cart_id" or rename "items" => "cartId" as for the Abandoned Cart
        const [sku, cartId, abandonedCart] = Url.getParametes(["sku", "cart_id", "cartId"]);

        if (sku ?? cartId ?? abandonedCart) {
            let subscription = { refs: [] };

            Storage.set("current_purchase", sku ?? cartId ?? abandonedCart);

            if (sku) {
                subscription = {
                    refs: [
                        {
                            item: sku,
                            quantity: 1,
                        },
                    ],
                };
            }

            return {
                type: window.snakeCheckout.type,
                store_code: (import.meta.env.CO_BRAND === "deagostini" ? "PW" : "FH") + window.snakeCheckout.currentCountry.toUpperCase(),
                cart_id: cartId ?? abandonedCart ?? "",
                ...subscription,
            };
        }

        return null;
    };

    static #initAgentCustomerCheckout = async () => {
        Trace.debug("initAgentCustomerCheckout");

        await Identity._gproxyLoader(Url.getParametes("token"));

        if (Identity.isAuth()) {
            Trace.warn("AgentCustomer AUTH");

            await Identity.signOut().catch((e) => {
                Trace.warn("AgentCustomer signOut");

                /**
                 *  If error 403007 "Invalid namespace &#39;accounts&#39; or method &#39;logout&#39; or you do not have the required permissions to call it." + "Permission denied"
                 *
                 *  TODO: ask why
                 */
                if (e.errorCode !== 403007) AnalyticsService.errorEvent("0_init", "technical", "agent, gproxy | sign-out error", e);
            });
        }

        Storage.clear(() => {
            Storage.set("agentCustomer", true);
        });

        Component.load(config.routing.sections.load.component);
    };

    static #renderSubscriptionThankYouPage = async () => {
        Utils.spinner("loader", true);

        const initData = JSON.parse(Storage.get("init"));

        const productCode = initData?.products[0]?.code ?? null;

        await this.#renderThankYouPage("subscription", productCode);

        Utils.spinner("loader", false);
    };

    static #renderItemsThankYouPage = async () => {
        Trace.warn("renderItemsThankYouPage");

        Utils.spinner("loader", true);

        document.querySelector("body").classList.add("thank-you-items");

        // const currentCountry = Url.getCurrentUri().split("/")[1];

        const itemsDom = document.querySelector("#items");

        Trace.print(JSON.parse(Storage.get("items")) ?? []);
        Trace.print(JSON.parse(Storage.get("currency")) ?? null);

        // const currencyFormat = JSON.parse(Storage.get("currency")) ?? null;

        (JSON.parse(Storage.get("items")) ?? []).forEach((item) => {
            itemsDom.appendChild(document.querySelector("template#tpl-item").content.cloneNode(true));

            const itemDom = itemsDom.lastElementChild;

            itemDom.querySelector("img").src = item.image ?? "";
            itemDom.querySelector("itemtitle").outerHTML = item.name ?? "";

            if ((item.quantity ?? 0) > 1) itemDom.querySelector("itemquantity").outerHTML = "x " + item.quantity ?? 0;
            else itemDom.querySelector("itemquantity").parentElement.parentElement.parentElement.remove();

            // itemDom.querySelector("itemoriginalprice").outerHTML = this.#formatPrice(item.price ?? 0, config.countries[currentCountry].currencySymbol, currencyFormat?.currencyIconPosition ?? "after", currencyFormat?.currencyDecimalDivider ?? "comma");
            // itemDom.querySelector("itemprice").outerHTML = Summary.formatPrice(item.price ?? 0, config.countries[currentCountry].currencySymbol, currencyFormat?.currencyIconPosition ?? "after", currencyFormat?.currencyDecimalDivider ?? "comma");
        });

        await this.#renderThankYouPage("items");

        Utils.spinner("loader", false);
    };

    static #renderThankYouPage = async (type, productCode = null) => {
        const modalI18nGenericOptions = Component.getModalI18nGenericOptions();
        const currentCountry = Url.getCurrentUri().split("/")[1];

        await Identity._gproxyLoader();

        if (productCode && Identity.isAuth()) {
            await Identity.purchaseAdd(productCode).catch((e) => {
                Utils.modal("popup", true, modalI18nGenericOptions);

                AnalyticsService.errorEvent("4_typ", "technical", "gproxy | purchase add error", e);

                throw new Error("gproxy purchase add error");
            });
        }

        document.querySelector("#oid").innerText = Storage.get("IOD");
        document.querySelector("#user_greetings").innerText = window.snakeCheckout.translations["thankyou.text.greetings"].replace("%s", Storage.get("firstname") ?? "");

        const shippingTextDom = document.querySelector("#shippinge_text");
        if (shippingTextDom) {
            const shippingText = Storage.get("shipping_text");
            if (shippingText) shippingTextDom.innerText = shippingText;
            else shippingTextDom.remove();
        }

        ApiService.orderDetails({ order_id: Storage.get("order") })
            .then(async (response) => {
                Trace.log("ApiService.orderDetails");
                Trace.print(response);

                if (type === "subscription" && productCode) {
                    const imageWrapper = document.querySelector("#image");

                    imageWrapper.innerLoader(true);

                    fetch(import.meta.env.CO_SNAKE_API_CACHED + "/api/v1/core/service/product/asset?country=" + currentCountry + "&code=" + productCode + "&type=default")
                        .then((response) => response.blob())
                        .then((response) => {
                            document.querySelector("#image img").src = URL.createObjectURL(response);

                            imageWrapper.innerLoader(false);
                        })
                        .catch((e) => {
                            AnalyticsService.errorEvent("4_typ", "technical", "snakeAPI | get product image error", e);

                            imageWrapper.innerLoader(false);
                        });
                }

                const customerDefaultShippingAddress = JSON.parse(Storage.get("shipping_address"));
                const shippingAddressArray = customerDefaultShippingAddress ? [customerDefaultShippingAddress?.addressLine1 ?? "", customerDefaultShippingAddress?.addressLine2 ?? "", customerDefaultShippingAddress?.addressLine3 ?? "", customerDefaultShippingAddress?.postalCode ?? "", customerDefaultShippingAddress?.city ?? ""] : [response.data.shipping_addresses[0].street_1, response.data.shipping_addresses[0].zip, response.data.shipping_addresses[0].city];

                document.querySelector("#shipping_address").innerText = shippingAddressArray
                    .map((y) => y.trim())
                    .filter((x) => x !== "")
                    .join(", ");

                const isoLang = (config.countries[currentCountry].lang || currentCountry) + "-" + config.countries[currentCountry]?.countryCode;

                const formatCurrency = new Intl.NumberFormat(isoLang, {
                    style: "currency",
                    currency: config.countries[currentCountry].currencyCode,
                });

                let revenue, shipping;

                if (type === "subscription") revenue = response.data?.products[0].base_price;
                else {
                    revenue = Storage.get("price");
                    shipping = Storage.get("shipping");

                    if (document.querySelector("#welcome_package_shipping")) document.querySelector("#welcome_package_shipping").innerText = shipping ? window.snakeCheckout.translations["thankyou.shipping"] + " " + formatCurrency.format(shipping) : "";
                }

                const paymentMethod = Storage.get("payment_method");

                if (paymentMethod !== "") {
                    const paymentMethodElement = document.querySelector("#payment_method");

                    switch (paymentMethod) {
                        case "paypal":
                            paymentMethodElement.innerText = "PayPal";
                            break;
                        case "card":
                            paymentMethodElement.innerText = window.snakeCheckout.translations["payment.creditcard.name"];
                            break;
                        case "sepadirectdebit":
                            paymentMethodElement.innerText = window.snakeCheckout.translations["payment.sepa.name"];
                            break;
                        case "c_invoice":
                            paymentMethodElement.innerText = window.snakeCheckout.translations["payment.invoice.name"];
                            break;
                        case "c_cash":
                            paymentMethodElement.innerText = window.snakeCheckout.translations["payment.cash.name"];
                            break;
                        case "klarna_account":
                            paymentMethodElement.innerText = window.snakeCheckout.translations["payment.klarna.name"] ?? "Klarna";
                            break;
                        default:
                            paymentMethodElement.innerText = paymentMethod;
                            break;
                    }
                }

                const firstPackagePriceDom = document.querySelector("#welcome_package_price");

                if (firstPackagePriceDom && paymentMethod !== "klarna_account") firstPackagePriceDom.innerText = revenue ? formatCurrency.format(revenue) + (currentCountry === "us" ? " + taxes" : "") : "";
                else firstPackagePriceDom.parentElement.remove();

                if (Storage.get("order")) {
                    AnalyticsService.checkoutPurchaseDone(revenue, async () => {
                        if (Identity.isAuth()) {
                            await Identity.signOut().catch((e) => {
                                /**
                                 *  If error 403007 "Invalid namespace &#39;accounts&#39; or method &#39;logout&#39; or you do not have the required permissions to call it." + "Permission denied"
                                 *
                                 *  TODO: ask why
                                 */
                                if (e.errorCode !== 403007) AnalyticsService.errorEvent("4_typ", "technical", "gproxy | sign-out error", e);
                            });
                        }

                        Storage.clear();
                    });
                }
            })
            .catch((e) => {
                AnalyticsService.errorEvent("4_typ", "technical", "gproxy | get order details error", e);
            });
    };

    static #renderAgentThankYouPage = () => {
        Utils.spinner("loader", true);

        document.querySelector("body header #logo").dataset.agent = "Agent";
        document.querySelector("header #phone").remove();
        document.querySelector("header #chat").classList = "hidden";

        Utils.spinner("loader", false);
    };
}
